import type { SearchResultV2 } from "@rsc/scripture-model";

export function searchTextSegments(
  result: { matches: SearchResultV2["matches"]; verse: { text: string } },
  options: { omitHeadings?: boolean; onlyHeadings?: boolean } = {},
) {
  const text = result.verse.text;
  const spans = result.matches
    .filter(
      (m) =>
        Number.isInteger(m.start) &&
        Number.isInteger(m.end) &&
        m.start >= 0 &&
        m.end > m.start &&
        m.end <= text.length,
    )
    .map((m) => ({ ...m }))
    .sort((a, b) => a.start - b.start);
  const merged: { start: number; end: number }[] = [];
  for (const span of spans) {
    const last = merged[merged.length - 1];
    if (last && span.start <= last.end) last.end = Math.max(last.end, span.end);
    else merged.push(span);
  }
  const segments: { text: string; match: boolean; emphasis?: boolean }[] = [];
  let offset = 0;
  let emphasis = false;
  let inHeading = false;
  function append(from: number, to: number) {
    if (
      (options.omitHeadings && inHeading) ||
      (options.onlyHeadings && !inHeading)
    )
      return;
    const boundaries = [
      ...new Set([
        from,
        to,
        ...merged
          .flatMap((span) => [span.start, span.end])
          .filter((n) => n > from && n < to),
      ]),
    ].sort((a, b) => a - b);
    for (let i = 0; i < boundaries.length - 1; i++) {
      const start = boundaries[i]!;
      const end = boundaries[i + 1]!;
      segments.push({
        text: text.slice(start, end),
        match: merged.some((span) => span.start <= start && span.end >= end),
        ...(emphasis ? { emphasis: true } : {}),
      });
    }
  }
  // Match offsets refer to source text, before removing presentation markers.
  for (const token of text.matchAll(/\[(\/?(?:h|i)|br)\]/g)) {
    append(offset, token.index);
    if (token[1] === "h") inHeading = true;
    if (token[1] === "/h") inHeading = false;
    if (token[1] === "i") emphasis = true;
    if (token[1] === "/i") emphasis = false;
    if ((token[1] === "/h" && !options.omitHeadings) || token[1] === "br")
      segments.push({ text: "\n", match: false });
    offset = token.index + token[0].length;
  }
  append(offset, text.length);
  return segments;
}
